import { get, init } from "./schedule.js";

function delayFunction(id, value) {
  return function () {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function () {
    init(this, id).delay = value;
  };
}

export default function (value) {
  var id = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : get(this.node(), id).delay;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/transition/delay.js
// module id = 478
// module chunks = 0